// extracted by mini-css-extract-plugin
export var legendIndicator = "_eb-1";
export var legendRight = "_eb-0";